import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signOut as authSignOut, connectAuthEmulator } from 'firebase/auth';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import type { Email, Uid } from '../cross-app-shared/types/common';
import { ref } from 'vue';
import { UNIT_TEST } from '../cross-app-shared/services/automated-testing.ts';

export const app = initializeApp(FIREBASE_OPTIONS);
export const auth = getAuth(app);
export const storage = getStorage(app);

if (FIREBASE_USING_EMULATORS) {
  connectAuthEmulator(auth, 'http://localhost:9099');
  connectStorageEmulator(storage, 'localhost', 9199);
}
export let uid: Uid = (UNIT_TEST ? 'testtesttesttestesttesttestt' : '') as Uid;
export let email: Email = 'not.yet.authenticated@example.com' as Email;
export const loginState = ref<'initializing' | 'logged-out' | 'logged-in'>('initializing');
let userLoginStateConfirmedPromiseResolve = () => {};
export const userLoginStateConfirmedPromise = new Promise<void>(
  (resolve) => (userLoginStateConfirmedPromiseResolve = resolve),
);
let userConfirmedLoggedInPromiseResolve = () => {};
export const userConfirmedLoggedInPromise = new Promise<void>(
  (resolve) => (userConfirmedLoggedInPromiseResolve = resolve),
);

if (FIREBASE_USING_EMULATORS) {
  userConfirmedLoggedInPromise.then(() => document.querySelector('.firebase-emulator-warning')?.remove());
}

onAuthStateChanged(auth, async (user) => {
  if (user) {
    uid = user.uid as Uid;
    email = user.email! as Email;
    loginState.value = 'logged-in';
    userConfirmedLoggedInPromiseResolve();

    // Refresh the session cookie so that image downloads and such work:
    try {
      const idToken = await auth.currentUser?.getIdToken();
      if (idToken) {
        await fetch('/api/crossapp/set-session-cookie', {
          method: 'POST',
          body: idToken,
        });
      }
    } catch (e) {
      console.error('Failed to refresh session cookie.', e);
    }
  } else {
    loginState.value = 'logged-out';
  }
  userLoginStateConfirmedPromiseResolve();
});

export function signOut(): Promise<void> {
  return fetch('/api/crossapp/clear-session-cookie', { method: 'POST' })
    .catch((error) => {
      console.error('Failed to clear session cookie during logout.', error);
    })
    .then(() => authSignOut(auth));
}
